var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/results/optimal_solution.template.html');
var Handlebars = require('../../../libs/handlebars/handlebars-v4.0.5.js');

var TheView = GenericView.extend({
    el: '#optimal_solution',
    tagName: '',
	template: Handlebars.compile(Template),
	data: null,
	initialize: function (options) {
	    this.data = options.data;
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template(this.data));
        this.createNominalCFChart();
        this.createDiscountedCFChart();
    },
    events: {
        "click #exportOptimal" : "exportData"
    },
    createNominalCFChart: function() {
        var ctx = document.getElementById('nominalCFChart').getContext('2d');
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: this.data.year,
                datasets: [
                    {
                        label: "Capex PV (€)",
                        backgroundColor: "#ed7d31",
                        data: $.map(this.data.noCF, function(element) {
                                  return element.capexPv;
                              })
                    },
                    {
                        label: "Capex BESS (€)",
                        backgroundColor: "#a5a5a5",
                        data: $.map(this.data.noCF, function(element) {
                                    return element.capexBess;
                                })
                    },
                    {
                         label: "Subsidies (€)",
                         backgroundColor: "#ffc000",
                         data: $.map(this.data.noCF, function(element) {
                                         return element.subsidies;
                                     })
                    },
                    {
                        label: "Opex PV (€)",
                        backgroundColor: "#4472c4",
                        data: $.map(this.data.noCF, function(element) {
                                        return element.opexPv;
                                    })
                    },
                    {
                        label: "Opex BESS (€)",
                        backgroundColor: "#70ad47",
                        data: $.map(this.data.noCF, function(element) {
                                return element.opexBess;
                            })
                    },
                    {
                        label: "Net Energy Benefits (€)",
                        backgroundColor: "#255e91",
                        data: $.map(this.data.noCF, function(element) {
                                return element.netEnergyBenefits;
                            })
                    },
                    {
                        label: "Nominal Cash Flow (€)",
                        borderColor: "#9e480e",
                        data: $.map(this.data.noCF, function(element) {
                                  return element.discountedCashFlow;
                              }),
                        type: 'line'
                    },
                ]
            },
            options: {
                responsive: true,
                aspectRatio: 3,
                maintainAspectRatio: false,
                title: {
                    display: true,
                    text: 'Nominal Cash Flow',
                    fontSize: '20'
                },
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Year'
                        }
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Cost-Benefit (€)'
                        }
                    }]
                }
            }
        });

        myChart.canvas.parentNode.style.height = '400px';
        myChart.canvas.parentNode.style.width = '90%';

    },
    createDiscountedCFChart: function() {
        var ctx = document.getElementById('discountedCFChart').getContext('2d');
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: this.data.year,
                datasets: [
                    {
                        label: "Capex PV (€)",
                        backgroundColor: "#ed7d31",
                        data: $.map(this.data.diCF, function(element) {
                                  return element.capexPv;
                              })
                    },
                    {
                        label: "Capex BESS (€)",
                        backgroundColor: "#a5a5a5",
                        data: $.map(this.data.diCF, function(element) {
                                    return element.capexBess;
                                })
                    },
                    {
                         label: "Subsidies (€)",
                         backgroundColor: "#ffc000",
                         data: $.map(this.data.diCF, function(element) {
                                     return element.subsidies;
                                 })
                    },
                    {
                        label: "Opex PV (€)",
                        backgroundColor: "#4472c4",
                        data: $.map(this.data.diCF, function(element) {
                                    return element.opexPv;
                                })
                    },
                    {
                        label: "Opex BESS (€)",
                        backgroundColor: "#70ad47",
                        data: $.map(this.data.diCF, function(element) {
                                    return element.opexBess;
                                })
                    },
                    {
                        label: "Net Energy Benefits (€)",
                        backgroundColor: "#255e91",
                        data: $.map(this.data.diCF, function(element) {
                                    return element.netEnergyBenefits;
                                })
                    },
                    {
                        label: "Discounted Cash Flow (€)",
                        borderColor: "#9e480e",
                        data: $.map(this.data.diCF, function(element) {
                                  return element.discountedCashFlow;
                              }),
                        type: 'line'
                    },
                ]
            },
            options: {
                responsive: true,
                aspectRatio: 3,
                maintainAspectRatio: false,
                title: {
                    display: true,
                    text: 'Discounted Cash Flow',
                    fontSize: '20'
                },
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Year'
                        }
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Cost-Benefit (€)'
                        }
                    }]
                }
            }
        });

        myChart.canvas.parentNode.style.height = '400px';
        myChart.canvas.parentNode.style.width = '90%';

    },
     exportData: function() {
          var self = this;

          $.ajax({
              url: "/api/export/optimalSolution",
              type: "POST",
              contentType: "application/json",
              data: JSON.stringify({
                        npv: Handlebars.helpers.decimalDigits(self.data.generalOutputs.maxNPV,2),
                        irr: Handlebars.helpers.decimalDigits(self.data.generalOutputs.irr,2),
                        spp: Handlebars.helpers.decimalDigits(self.data.generalOutputs.spp,2),
                        pvSize: Handlebars.helpers.decimalDigits(self.data.generalOutputs.optimal_PVsize,1),
                        batSize: Handlebars.helpers.decimalDigits(self.data.generalOutputs.optimal_BATsize,1),
                        ncf: self.data.noCF,
                        dcf: self.data.diCF
               }),
              dataType : 'binary',
              xhrFields : {
                 'responseType' : 'blob'
              }
          }).done(function(response) {
             var url = URL.createObjectURL(response);
             var $a = $('<a />', {
               'href': url,
               'download': 'OptimalSolution.csv',
               'text': "click"
             }).hide().appendTo("body")[0].click()
          }).fail(function(resp, xhr, errorMessage) {
              console.error("resp: ", resp);
              console.error("xhr: ", xhr);
              console.error("status: ", errorMessage);
          });

     }
});

module.exports= TheView;